module.exports = __webpack_public_path__ + "static/media/s3@2x.9d0746ec.png";